import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import * as ApiRoute from 'constants/apiRouting'
import { LOGBOOK_DAILY } from 'constants/requestTypes'
import {
  FETCH_EVENT_DATA_LIST,
  SUCCESS_EVENT_DATA_LIST,
  FAILURE_EVENT_DATA_LIST,
  SET_LOADER_FROM_EVENT_DATA_LIST,
  FETCH_LOCUS_GROUP_LIST,
  SUCCESS_LOCUS_GROUP_LIST,
  FAILURE_LOCUS_GROUP_LIST,
  FETCH_EVENT_DATA_ITEM,
  SUCCESS_EVENT_DATA_ITEM,
  FAILURE_EVENT_DATA_ITEM,
  FETCH_EVENT_FORM_LISTS,
  SUCCESS_EVENT_FORM_LISTS,
  SUCCESS_EVENT_FORM_EVENTS,
  SUCCESS_EVENT_FORM_CATEGORIES,
  FAILURE_EVENT_FORM_LISTS,
  FAILURE_EVENT_FORM_EVENTS,
  FAILURE_EVENT_FORM_CATEGORIES,
  FETCH_EVENT_FORM_INFO,
  SUCCESS_EVENT_FORM_INFO,
  FAILURE_EVENT_FORM_INFO,
  FETCH_LOGBOOK_STATUS,
  FETCH_LOGBOOK_SITE_GROUPS,
  SUCCESS_LOGBOOK_STATUS,
  FAILURE_LOGBOOK_STATUS,
  SUCCESS_LOGBOOK_SITE_GROUPS,
  LOAD_LOGBOOK_STATUS,
  LOAD_LOGBOOK_SITE_GROUPS,
  FETCH_EVENT_LIST,
  SUCCESS_EVENT_LIST,
  FAILURE_EVENT_LIST,
  FETCH_SINGLE_EVENT_DATA,
  SUCCESS_SINGLE_EVENT_DATA,
  FAILURE_SINGLE_EVENT_DATA,
  FETCH_SINGLE_FILLED_EVENT_DATA,
  SUCCESS_SINGLE_FILLED_EVENT_DATA,
  FAILURE_SINGLE_FILLED_EVENT_DATA,
  SAVE_EVENT_FORM,
  DELETE_EVENT,
  SAVE_DAILY_ENTRY,
  SAVE_BATCH_INPUTS,
} from './reducer'
import { SHOW_NOTICE } from '../notice'

function* fetchEventDataList({ payload }) {
  try {
    yield put({ type: SET_LOADER_FROM_EVENT_DATA_LIST, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        `${ApiRoute.EVENT_DATA_LIST}${UrlHelper.getPsfsQuery(payload)}`,
        payload.params,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_EVENT_DATA_LIST, payload: response })
    } else {
      yield put({ type: FAILURE_EVENT_DATA_LIST })
    }

    yield put({ type: SET_LOADER_FROM_EVENT_DATA_LIST, payload: false })
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchLocusGroupsList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.LOCUS_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_LIST })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchEventDataItem(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.EVENT_DATA_ITEM, action.payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_EVENT_DATA_ITEM, payload: response })
    } else {
      yield put({ type: FAILURE_EVENT_DATA_ITEM })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchEventFormList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.EVENT_FORM_LISTS, action.payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_EVENT_FORM_LISTS, payload: response })
      yield put({ type: SUCCESS_EVENT_FORM_EVENTS, payload: response.events })
      yield put({
        type: SUCCESS_EVENT_FORM_CATEGORIES,
        payload: response.categories,
      })
    } else {
      yield put({ type: FAILURE_EVENT_FORM_LISTS })
      yield put({ type: FAILURE_EVENT_FORM_EVENTS })
      yield put({ type: FAILURE_EVENT_FORM_CATEGORIES })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchEventFormInfo(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.LOGBOOK_SINGLE_EVENT, action.payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_EVENT_FORM_INFO, payload: response })
    } else {
      yield put({ type: FAILURE_EVENT_FORM_INFO })
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchLogbookSiteGroups(action) {
  try {
    yield put({ type: LOAD_LOGBOOK_SITE_GROUPS, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        `${ApiRoute.SITE_GROUPS}${UrlHelper.getPsfsQuery(action.payload)}`,
      ),
    })

    if (response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'Error fetching logbook site groups!',
        ),
      })
    } else {
      yield put({ type: SUCCESS_LOGBOOK_SITE_GROUPS, payload: response })
    }

    yield put({ type: LOAD_LOGBOOK_SITE_GROUPS, payload: false })
  } catch (error) {
    console.log('LOGBOOK SITE GROUPS FAILED ', error)
  }
}

function* fetchLogbookStatus({ payload }) {
  try {
    yield put({ type: LOAD_LOGBOOK_STATUS, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(ApiRoute.STATUS_INFO, payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_LOGBOOK_STATUS, payload: response })
    } else {
      yield put({ type: FAILURE_LOGBOOK_STATUS })
    }

    yield put({ type: LOAD_LOGBOOK_STATUS, payload: false })
  } catch (error) {
    console.log('LOGBOOK STATUS FAILED ', error)
  }
}

function* saveEventForm(action) {
  try {
    const { id, form, params } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        id ? ApiRoute.LOGBOOK_SINGLE_EVENT_FILLED : ApiRoute.LOGBOOK_ENTRY_SAVE,
        id || params,
      ),
      method: id ? 'PUT' : 'POST',
      data: form,
    })

    if (response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('Fields should not be empty'),
      })

      return yield call(action.promise.resolve, response)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj('Event change successful!'),
    })

    if (action.promise) {
      yield call(action.promise.resolve, false)
    }
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* deleteEvent(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.EVENT_DATA_ITEM, {
        id: action.payload.id,
      }),
      method: 'DELETE',
    })

    if (response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('Event not delete!'),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Event delete successful!'),
      })
    }

    yield call(action.promise.resolve, false)
  } catch (error) {
    console.log('SLA ENVIRONMENT FAILED ', error)
  }
}

function* fetchEventList({ payload, promise }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.LOGBOOK_EVENT_LIST, payload),
    })

    if (response && !response.error) {
      yield put({
        type: SUCCESS_EVENT_LIST,
        payload: response,
      })
    } else {
      if (
        response.message &&
        response.message !== '' &&
        payload.type !== LOGBOOK_DAILY
      ) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({
        type: FAILURE_EVENT_LIST,
        error: response.error,
      })
    }

    if (promise && promise.hasOwnProperty('resolve')) {
      yield call(promise.resolve, false)
    }
  } catch (error) {
    console.log('FETCH DAILY EVENTS FAILED ', error)
  }
}

function* saveBatchInputs({ payload: { params, data, message }, promise }) {
  try {
    const uri = ApiRoute.LOGBOOK_BATCH_INPUTS
    const method = 'POST'
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(uri, params),
      method,
      data,
    })

    if (response && response.errors) {
      yield call(promise.resolve, { errors: response.errors })

      if (response.status !== 400 && response.message) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.error.message),
        })
      }
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(message),
      })
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('SAVE BATCH INPUTS FAILED ', error)
  }
}

function* saveDailyEntry({ payload, promise }) {
  const { params, data, message } = payload

  try {
    const uri = params.event
      ? ApiRoute.LOGBOOK_SINGLE_EVENT_FILLED
      : ApiRoute.LOGBOOK_ENTRY_SAVE
    const method = params.event ? 'PUT' : 'POST'
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(uri, params),
      method,
      data,
    })

    if (response && response.errors) {
      yield call(promise.resolve, { errors: response.errors })

      if (response.status !== 400 && response.message) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.error.message),
        })
      }
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(message),
      })
      yield call(promise.resolve, response)
    }
  } catch (error) {
    console.log('SAVE DAILY ENTRY FAILED ', error)
  }
}

function* fetchSingleEventData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.LOGBOOK_SINGLE_EVENT, action.payload),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_SINGLE_EVENT_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_SINGLE_EVENT_DATA, error: response.errors })
    }
  } catch (error) {
    console.log('FETCH SINGLE EVENT DATA FAILURE ', error)
  }
}

function* fetchSingleFilledEventData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.LOGBOOK_SINGLE_EVENT_FILLED,
        action.payload,
      ),
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_SINGLE_FILLED_EVENT_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({
        type: FAILURE_SINGLE_FILLED_EVENT_DATA,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('FETCH SINGLE FILLED EVENT DATA ', error)
  }
}

function* logbookSaga() {
  yield takeLatest(FETCH_EVENT_DATA_LIST, fetchEventDataList)
  yield takeLatest(FETCH_LOCUS_GROUP_LIST, fetchLocusGroupsList)
  yield takeLatest(FETCH_EVENT_DATA_ITEM, fetchEventDataItem)
  yield takeLatest(FETCH_EVENT_FORM_LISTS, fetchEventFormList)
  yield takeLatest(FETCH_EVENT_FORM_INFO, fetchEventFormInfo)
  yield takeLatest(FETCH_EVENT_LIST, fetchEventList)
  yield takeLatest(FETCH_LOGBOOK_STATUS, fetchLogbookStatus)
  yield takeLatest(FETCH_LOGBOOK_SITE_GROUPS, fetchLogbookSiteGroups)
  yield takeLatest(SAVE_EVENT_FORM, saveEventForm)
  yield takeLatest(DELETE_EVENT, deleteEvent)
  yield takeLatest(SAVE_DAILY_ENTRY, saveDailyEntry)
  yield takeLatest(SAVE_BATCH_INPUTS, saveBatchInputs)
  yield takeLatest(FETCH_SINGLE_EVENT_DATA, fetchSingleEventData)
  yield takeLatest(FETCH_SINGLE_FILLED_EVENT_DATA, fetchSingleFilledEventData)
}

export default logbookSaga
